/**
 * useSubCasteListScreen.js
 * ------------------------
 * Hook for Sub-Caste Master list screen using shared useMasterList and background JobEngine export.
 */
import { useMasterList } from '../../common/useMasterList';
import * as subCasteApi from '../api/subCasteApi';
import { useExportJob } from '../../../../hooks/useExportJob';

export function useSubCasteListScreen() {
  const master = useMasterList({
    entityName: 'Sub-Caste',
    apiClient: subCasteApi.subCasteClient,
    fetchList: subCasteApi.listSubCastes,
    archiveItem: subCasteApi.archiveSubCaste,
    deleteItem: subCasteApi.deleteSubCaste,
  });

  const { triggerExport, isExporting } = useExportJob({
    module: 'sub_caste',
    fileFormat: 'XLSX',
  });

  const handleToolSelect = (toolKey) => {
    if (toolKey === 'download' || toolKey === 'export_excel') {
      triggerExport({
        viewMode: master.state.viewMode,
        searchText: master.state.searchText,
      });
    }
  };

  return {
    ...master,
    state: {
      ...master.state,
      isExporting,
    },
    actions: {
      ...master.actions,
      handleToolSelect,
    },
  };
}
